import React, { useState } from "react";
import {
  WhmBox,
  WhmStack,
  whmTheme,
  WhmTypography,
} from "@securitize/reactjs-whm";
import { Translate, TranslateHtml } from "../../Translation/Translate";
import { ReactComponent as ChevronUp } from "@securitize/assets-sec-ui/dist/icons/svg/arrow-up.svg";
import { ReactComponent as ChevronDown } from "@securitize/assets-sec-ui/dist/icons/svg/arrow-down.svg";
import translationKeys from "../../../contexts/I18nContext/translationKeys";

interface EntityOnboardingAdditionalInfoSectionProps {
  comment?: string;
}

export default function EntityOnboardingAdditionalInfoSection({
  comment,
}: EntityOnboardingAdditionalInfoSectionProps) {
  const [open, setOpen] = useState(false);

  if (!comment) {
    return null;
  }

  return (
    <WhmBox sx={{ paddingTop: "16px" }}>
      <WhmStack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap="8px"
        onClick={() => setOpen(!open)}
        sx={{ "&:hover": { cursor: "pointer" } }}
      >
        <WhmBox sx={{ flex: 1 }}>
          <WhmTypography
            variant="subtitle1"
            sx={{ color: whmTheme.palette.text.primary }}
          >
            <Translate
              translationKey={
                translationKeys.ONBOARDING_CARD_UPDATES_REQUIRED_SECTION_ADDITIONAL_INFORMATION
              }
            />
          </WhmTypography>
          <WhmTypography
            variant="body2"
            sx={{ color: whmTheme.palette.text.secondary }}
          >
            <TranslateHtml
              translationKey={
                translationKeys.ONBOARDING_CARD_UPDATES_REQUIRED_SECTION_ADDITIONAL_INFORMATION_SUBTITLE
              }
            />
          </WhmTypography>
        </WhmBox>
        <WhmBox
          component={open ? ChevronUp : ChevronDown}
          sx={{
            color: whmTheme.palette.text.secondary,
            fill: whmTheme.palette.text.secondary,
            flexShrink: 0,
          }}
        />
      </WhmStack>

      {open && (
        <WhmTypography
          variant="body2"
          sx={{
            color: whmTheme.palette.text.secondary,
            paddingTop: "12px",
            overflowWrap: "break-word",
            wordBreak: "break-word",
            whiteSpace: "pre-wrap",
          }}
        >
          {comment}
        </WhmTypography>
      )}
    </WhmBox>
  );
}
